import React, { useState, useEffect } from "react";
import { makeRequestAuth, uploadFiles } from "../../_config/api";
import { toast } from "react-toastify";
import { FiTrash2, FiPlus } from "react-icons/fi";

export default function BannerManagement() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
const [deleteModal, setDeleteModal] = useState({ isOpen: false, bannerId: null });

  const [formData, setFormData] = useState({
    title: "",
    highlight: "",
    img: "",
    link:"",
    tabCategory: "Buy Property", 
  });


  
  const fetchBanners = async () => {
    try {
      setLoading(true);
      const res = await makeRequestAuth("post", "/admin/getHeroBanners", {});
      if (res?.data?.list) {
        setBanners(res.data.list);
      }
    } catch (err) {
      toast.error("Failed to load banners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // Upload Image to Backend upload API
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const res = await uploadFiles({
        files: [file],
        endpoint: "/uploadImage",
        fieldName: "file",
        isMultiple: false,
      });

      if (res?.data?.imageUrl) {
        setFormData((prev) => ({ ...prev, img: res.data.imageUrl }));
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      toast.error("Image upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.img) {
      return toast.error("Please upload a banner image!");
    }

    try {
      const res = await makeRequestAuth("post", "/admin/createHeroBanner", formData);
      if (res) {
        toast.success("Banner added successfully!");
        setFormData({ title: "", highlight: "", img: "", link:"", tabCategory: "Buy Property" });
        fetchBanners();
      }
    } catch (err) {
      toast.error("Failed to create banner");
    }
  };

    // Button click par sirf modal open hoga
  const handleDeleteClick = (id) => {
    setDeleteModal({ isOpen: true, bannerId: id });
  };

  // Asli delete API call yahan hogi
  const confirmDelete = async () => {
    try {
      const res = await makeRequestAuth("post", "/admin/deleteHeroBanner", { id: deleteModal.bannerId });
      if (res) {
        toast.success("Banner deleted successfully!");
        setDeleteModal({ isOpen: false, bannerId: null }); // Modal band karein
        fetchBanners(); // List refresh karein
      }
    } catch (err) {
      toast.error("Failed to delete banner");
    }
  };


  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Banner Management</h1>

      {/* Add Banner Form */}
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8">
        <h2 className="text-lg font-semibold mb-4 text-gray-700 flex items-center gap-2">
          <FiPlus className="text-[#24ADD7]" /> Add New Hero Banner
        </h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Title (e.g. FIND RENTAL HOMES)</label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-[#24ADD7]"
              placeholder="Title text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Highlight Text (e.g. IN YOUR CITY)</label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-[#24ADD7]"
              placeholder="Highlight text"
              value={formData.highlight}
              onChange={(e) => setFormData({ ...formData, highlight: e.target.value })}
            />
          </div>
          {/* ---- NAYA CODE YAHAN DAALEIN ---- */}
<div>
  <label className="block text-xs font-semibold text-gray-600 mb-1">Banner Link (e.g. https://google.com)</label>
  <input
    type="text"
    className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-[#24ADD7]"
    placeholder="Link URL"
    value={formData.link}
    onChange={(e) => setFormData({ ...formData, link: e.target.value })}
  />
</div> 
{/* --------------------------------- */}


           <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Category Tab</label>
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-[#24ADD7]"
              value={formData.tabCategory}
              onChange={(e) => setFormData({ ...formData, tabCategory: e.target.value })}
            >
              <option value="Buy Property">Buy Property</option>
              <option value="Rent Property">Rent Property</option>
              <option value="Home Services">Home Services</option>
              <option value="Loan Services">Loan Services</option>
            </select>
          </div> 

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Upload Banner Image</label>
            <input type="file" onChange={handleImageUpload} className="text-xs" accept="image/*" />
            {uploading && <span className="text-xs text-blue-500">Uploading...</span>}
            {formData.img && (
              <img src={formData.img} alt="Preview" className="h-16 mt-2 rounded object-cover border" />
            )}
          </div>

          <div className="md:col-span-2 mt-2">
            <button
              type="submit"
              disabled={uploading}
              className="bg-[#24ADD7] hover:bg-[#1c91b5] text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition shadow-md"
            >
              Save Banner
            </button>
          </div>
        </form>
      </div>

      {/* Banner Table */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <h2 className="text-lg font-semibold p-5 border-b text-gray-700">Existing Banners</h2>
        {loading ? (
          <p className="p-5 text-gray-500">Loading banners...</p>
        ) : banners.length === 0 ? (
          <p className="p-5 text-gray-400">No banners found. Add one above!</p>
        ) : (
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="bg-gray-50 text-gray-700 font-semibold border-b">
              <tr>
                <th className="p-4">Image</th>
                <th className="p-4">Title & Highlight</th>
                <th className="p-4">Category</th>
                <th className="p-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {banners.map((b) => (
                <tr key={b._id} className="border-b hover:bg-gray-50/50">
                  <td className="p-4">
                    <img src={b.img} alt={b.title} className="h-14 w-28 object-cover rounded-lg border" />
                  </td>
                  <td className="p-4">
                    <div className="font-bold text-gray-800">{b.title || "-"}</div>
                    <div className="text-xs text-[#24ADD7] font-semibold">{b.highlight || "-"}</div>
                  </td>
                  <td className="p-4">
                    <span className="bg-blue-50 text-[#24ADD7] text-xs font-semibold px-2.5 py-1 rounded-full">
                      {b.tabCategory}
                    </span>
                  </td>
                  <td className="p-4 text-center">
                 <button onClick={() => handleDeleteClick(b._id)} className="text-red-500 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition" title="Delete Banner">

                      <FiTrash2 className="text-lg" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
            {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl p-6 shadow-xl max-w-sm w-full mx-4">
            <h3 className="text-xl font-bold text-gray-800 mb-2">Delete Banner?</h3>
            <p className="text-gray-600 text-sm mb-6">
              Are you sure you want to delete this banner? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setDeleteModal({ isOpen: false, bannerId: null })}
                className="px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 rounded-lg transition"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 text-sm font-semibold text-white bg-red-500 hover:bg-red-600 rounded-lg transition"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
      
    </div> // <-- Yeh aapki file ka aakhri tag hai
  );
}
